<template>
  <header class="header w-full py-4 fixed lg:static">
    <div class="text-white text-center text-xl hidden lg:flex justify-between items-center px-3">
      <div class="flex-1">
        <!-- <div class="flex items-center" v-if="ai_sid">
          <a @click.native="logout()" href="https://aieta.liveabc.com/" class="md:flex text-sm hidden">返回AI小助教</a>
          <span class="mx-2">|</span>
          <a @click.native="logout()" :href="urlPath" class="md:flex text-sm hidden">學習記錄</a>
        </div> -->
        <router-link :to="{ name: 'Index' }" v-if="!ai_sid && !ai_uuid && queryS !== 'elab'" class="md:flex text-sm">返回AI學習首頁</router-link>
      </div>
      <div class="flex-1">
        <h6>{{ $t('head_title') }}</h6>
      </div>
      <div class="flex-1"></div>
    </div>
    <div class="lg:hidden flex justify-between items-center relative">
      <div class="pl-4">
        <img class="block h-auto mx-auto object-contain" src="@/assets/image/ai/logo_m.png" alt="">
      </div>
      <div class="px-4 py-2 cursor-pointer" @click="isOpenMenu = !isOpenMenu" v-if="(!ai_uuid && !$route.query.uuid) && (queryS !== 'elab')">
        <img class="block h-auto mx-auto object-contain" src="@/assets/image/ai/ham.png" alt="">
      </div>
      <aside class="sidenav absolute py-4 px-3 flex flex-col justify-between" :class="{ 'activeMenu': isOpenMenu }" v-if="(!ai_uuid && !$route.query.uuid) && (queryS !== 'elab')">
        <ul class="sidenav__list text-white list-none p-0 text-xl">
          <li class="sidenav__list_item mb-2" v-for="(item, index) in menuData" :key="index">
            <router-link :to="{ 'name': item.route_name, 'params': { promptId: item.promptId, aiType: item.aiType } }" @click.native="isOpenMenu = !isOpenMenu"
              class="m-0 flex items-center p-2"
              :class="{ 'active': ($route.name === item.route_name) && (item.promptId === $route.params.promptId) && (item.aiType === $route.params.aiType) }">
              <img src="@/assets/image/ai/Subtract.png" alt="" class="mr-2  object-contain">{{ item.name }}
            </router-link>
          </li>
        </ul>
        <div>
          <a v-if="!ai_sid && !ai_uuid" class="bg-red-main-ai text-white p-2 px-3 inline-block mb-2 text-sm cursor-pointer" @click.prevent="$store.dispatch('logout')">LOGOUT</a>
        </div>
      </aside>

    </div>
  </header>
</template>

<script>
// import LangSwitch from '@/components/langSwitch'
import { mapGetters } from 'vuex'
export default {
  name: 'headerSection',
  props: {
    menuData: {
      type: Array
    }
  },
  computed: {
    ...mapGetters([
      'lang',
      'remainPoints',
      'ai_sid',
      'ai_uuid'
    ]),
    queryS () {
      let s = this.$route.query.s || localStorage.getItem('s') || ''
      return s
    }
  },
  components: {
    },
  data () {
    return {
      isOpenMenu: true,
      screenWith: null,
      urlPath: 'https://aieta.liveabc.com/study_records.php'
    }
  },
  mounted () {
    window.addEventListener('resize', () => {
      this.screenWith = window.screen.width
    })
  },
  watch: {
    screenWith (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.isOpenMenu = false
      }
    }
  },
  methods: {
    closeMenu () {
      this.isOpenMenu = false
    },
    logout () {
      this.$store.dispatch('logout')
    }
  }
}
</script>
<style lang="scss" scoped>
.header {
  z-index: 99;
  background: #0E103E;
  @media (min-width: 1023px) {
    background: #5A5D9B;
  }
}
.sidenav {
  height: calc(100vh - 68px);
  background: #0E103E;
  z-index: 99;
  width: 100%;
  top: 100%;
  left: 100%;
  transition: .3s;
}
.activeMenu {
  left: 0 !important;
}
.active {
  background: linear-gradient(180deg, #F94F39 0%, #FF763C 100%);
}
</style>